import {
  SpaceBetween,
  Container,
  Box,
  ExpandableSection,
} from "@cloudscape-design/components-themed";
import Table from "./Table";
import ExaminationInfo from "./ExaminationInfo";
import Footer from "./Footer";
import { useParams } from "react-router-dom";
import { useGetExaminationContentQuery } from "../../features/api";
import {
  APPLICATION_TYPE_STORES,
  EXAMINATION_APPLICATION_MONTHLY_PERIODIC_CREDIT,
  EXAMINATION_STATUS_NO_NEED_TO_IMPLEMENT,
  EXAMINATION_TYPE_CHANGE,
  IExaminationTargetItems,
  LABELS,
  SETTLEMENT_TARGET_KUBUN,
  getExaminationStatusLabel,
  getExaminationStatusLabelMonthlyPeriodicCredit,
  getPosRegistrationStatusLabel,
} from "./constants";
import { useEffect } from "react";
import { formatDate } from "../../utils/format";
import { COMMON_LABELS } from "../default-constants";
import RelatedExaminationList from "./RelatedExaminationList";

/**
 * 審査内容照会
 */
export const Main = () => {
  const { examinationApplicationNo } = useParams();
  const { data: apiResponse, refetch } = useGetExaminationContentQuery({
    examinationApplicationNo: examinationApplicationNo!,
  });
  const isStore = APPLICATION_TYPE_STORES.includes(
    apiResponse?.applicationType ?? -1
  );
  const isChangeExamination =
    apiResponse?.examinationType === EXAMINATION_TYPE_CHANGE;
  const isOmni = apiResponse?.settlementTargetKubun === SETTLEMENT_TARGET_KUBUN;
  const examinationTargetItems: IExaminationTargetItems[] = [
    {
      examinationOrderTarget: LABELS.DOCOMO,
      examinationOrderDate:
        apiResponse?.docomoExaminationOrderTargetStatus ===
          COMMON_LABELS.HYPHEN &&
        apiResponse?.docomoExaminationOrderTargetDate === null
          ? COMMON_LABELS.HYPHEN
          : formatDate(apiResponse?.docomoExaminationOrderTargetDate ?? ""),
      examinationAnswerDate:
        apiResponse?.docomoExaminationOrderTargetStatus === COMMON_LABELS.HYPHEN
          ? COMMON_LABELS.HYPHEN
          : formatDate(apiResponse?.docomoExaminationAnswerDate ?? ""),
      examinationStatus:
        apiResponse?.docomoExaminationOrderTargetStatus ?? COMMON_LABELS.BLANK,
      posRegistrationOrderDate: COMMON_LABELS.HYPHEN,
      posRegistrationAnswerDate: COMMON_LABELS.HYPHEN,
      posRegistrationStatus: COMMON_LABELS.HYPHEN,
      merchantNo: COMMON_LABELS.HYPHEN,
      tenantMerchantNo: COMMON_LABELS.HYPHEN,
      accessKey: COMMON_LABELS.HYPHEN,
      secretKey: COMMON_LABELS.HYPHEN,
    },
    {
      examinationOrderTarget: LABELS.V_M_SMCC,
      vMTarget: apiResponse?.vmsmccValidInvalidFlg,
      examinationOrderDate: isOmni
        ? COMMON_LABELS.HYPHEN
        : formatDate(apiResponse?.vmsmccExaminationOrderTargetDate ?? ""),
      examinationAnswerDate: isOmni
        ? COMMON_LABELS.HYPHEN
        : formatDate(apiResponse?.vmsmccExaminationAnswerDate ?? ""),
      examinationStatus: isOmni
        ? COMMON_LABELS.HYPHEN
        : isChangeExamination
        ? COMMON_LABELS.HYPHEN
        : getExaminationStatusLabel(
            apiResponse?.vmsmccExaminationOrderTargetStatus ?? -1
          ),
      posRegistrationOrderDate: COMMON_LABELS.HYPHEN,
      posRegistrationAnswerDate: COMMON_LABELS.HYPHEN,
      posRegistrationStatus: COMMON_LABELS.HYPHEN,
      merchantNo: isOmni
        ? COMMON_LABELS.HYPHEN
        : apiResponse?.vmsmccMerchantNo ?? COMMON_LABELS.BLANK,
      tenantMerchantNo: COMMON_LABELS.HYPHEN,
      accessKey: COMMON_LABELS.HYPHEN,
      secretKey: COMMON_LABELS.HYPHEN,
    },
    {
      examinationOrderTarget: LABELS.V_M_TF,
      vMTarget: apiResponse?.vmtfValidInvalidFlg,
      examinationOrderDate: isOmni
        ? COMMON_LABELS.HYPHEN
        : formatDate(apiResponse?.vmtfExaminationOrderTargetDate ?? ""),
      examinationAnswerDate: isOmni
        ? COMMON_LABELS.HYPHEN
        : formatDate(apiResponse?.vmtfExaminationAnswerDate ?? ""),
      examinationStatus: isOmni
        ? COMMON_LABELS.HYPHEN
        : isChangeExamination
        ? COMMON_LABELS.HYPHEN
        : getExaminationStatusLabel(
            apiResponse?.vmtfExaminationOrderTargetStatus ?? -1
          ),
      posRegistrationOrderDate: isOmni
        ? COMMON_LABELS.HYPHEN
        : isStore
        ? COMMON_LABELS.HYPHEN
        : formatDate(apiResponse?.vmtfPosRegisterDate ?? ""),
      posRegistrationAnswerDate: isOmni
        ? COMMON_LABELS.HYPHEN
        : isStore
        ? COMMON_LABELS.HYPHEN
        : formatDate(apiResponse?.vmtfPosRegisterAnswerDate ?? ""),
      posRegistrationStatus: isOmni
        ? COMMON_LABELS.HYPHEN
        : isChangeExamination || isStore
        ? COMMON_LABELS.HYPHEN
        : getPosRegistrationStatusLabel(
            apiResponse?.vmtfPosRegisterStatus ?? -1
          ),
      merchantNo: isOmni
        ? COMMON_LABELS.HYPHEN
        : apiResponse?.vmtfMerchantNo ?? COMMON_LABELS.BLANK,
      tenantMerchantNo: isOmni
        ? COMMON_LABELS.HYPHEN
        : isStore
        ? apiResponse?.vmtfStoreNo ?? COMMON_LABELS.BLANK
        : COMMON_LABELS.HYPHEN,
      accessKey: COMMON_LABELS.HYPHEN,
      secretKey: COMMON_LABELS.HYPHEN,
    },
    {
      examinationOrderTarget: LABELS.V_M_SAISON,
      vMTarget: apiResponse?.vmsezonValidInvalidFlg,
      examinationOrderDate: isOmni
        ? COMMON_LABELS.HYPHEN
        : formatDate(apiResponse?.vmsezonExaminationOrderTargetDate ?? ""),
      examinationAnswerDate: isOmni
        ? COMMON_LABELS.HYPHEN
        : formatDate(apiResponse?.vmsezonExaminationAnswerDate ?? ""),
      examinationStatus: isOmni
        ? COMMON_LABELS.HYPHEN
        : isChangeExamination
        ? COMMON_LABELS.HYPHEN
        : getExaminationStatusLabel(
            apiResponse?.vmsezonExaminationOrderTargetStatus ?? -1
          ),
      posRegistrationOrderDate: COMMON_LABELS.HYPHEN,
      posRegistrationAnswerDate: COMMON_LABELS.HYPHEN,
      posRegistrationStatus: COMMON_LABELS.HYPHEN,
      merchantNo: isOmni
        ? COMMON_LABELS.HYPHEN
        : apiResponse?.vmsezonMerchantNo ?? COMMON_LABELS.BLANK,
      tenantMerchantNo: isOmni
        ? COMMON_LABELS.HYPHEN
        : isStore
        ? apiResponse?.vmsezonStoreNo ?? COMMON_LABELS.BLANK
        : COMMON_LABELS.HYPHEN,
      accessKey: COMMON_LABELS.HYPHEN,
      secretKey: COMMON_LABELS.HYPHEN,
    },
    {
      examinationOrderTarget: LABELS.JCB,
      examinationOrderDate: isOmni
        ? COMMON_LABELS.HYPHEN
        : isStore
        ? COMMON_LABELS.HYPHEN
        : formatDate(apiResponse?.jcbExaminationOrderTargetDate ?? ""),
      examinationAnswerDate: isOmni
        ? COMMON_LABELS.HYPHEN
        : isStore
        ? COMMON_LABELS.HYPHEN
        : formatDate(apiResponse?.jcbExaminationAnswerDate ?? ""),
      examinationStatus: isOmni
        ? COMMON_LABELS.HYPHEN
        : isChangeExamination || isStore
        ? COMMON_LABELS.HYPHEN
        : getExaminationStatusLabel(
            apiResponse?.jcbExaminationOrderTargetStatus ?? -1
          ),
      posRegistrationOrderDate: isOmni
        ? COMMON_LABELS.HYPHEN
        : isStore
        ? COMMON_LABELS.HYPHEN
        : formatDate(apiResponse?.jcbPosRegisterDate ?? ""),
      posRegistrationAnswerDate: isOmni
        ? COMMON_LABELS.HYPHEN
        : isStore
        ? COMMON_LABELS.HYPHEN
        : formatDate(apiResponse?.jcbPosRegisterAnswerDate ?? ""),
      posRegistrationStatus: isOmni
        ? COMMON_LABELS.HYPHEN
        : isChangeExamination || isStore
        ? COMMON_LABELS.HYPHEN
        : getPosRegistrationStatusLabel(
            apiResponse?.jcbPosRegisterStatus ?? -1
          ),
      merchantNo: isOmni
        ? COMMON_LABELS.HYPHEN
        : isStore
        ? COMMON_LABELS.HYPHEN
        : apiResponse?.jcbMerchantNo ?? COMMON_LABELS.BLANK,
      tenantMerchantNo: COMMON_LABELS.HYPHEN,
      accessKey: COMMON_LABELS.HYPHEN,
      secretKey: COMMON_LABELS.HYPHEN,
    },
    {
      examinationOrderTarget: LABELS.AMEX,
      examinationOrderDate: isOmni
        ? COMMON_LABELS.HYPHEN
        : isStore
        ? COMMON_LABELS.HYPHEN
        : formatDate(apiResponse?.amexExaminationOrderTargetDate ?? ""),
      examinationAnswerDate: isOmni
        ? COMMON_LABELS.HYPHEN
        : isStore
        ? COMMON_LABELS.HYPHEN
        : formatDate(apiResponse?.amexExaminationAnswerDate ?? ""),
      examinationStatus: isOmni
        ? COMMON_LABELS.HYPHEN
        : isChangeExamination || isStore
        ? COMMON_LABELS.HYPHEN
        : getExaminationStatusLabel(
            apiResponse?.amexExaminationOrderTargetStatus ?? -1
          ),
      posRegistrationOrderDate: isOmni
        ? COMMON_LABELS.HYPHEN
        : isStore
        ? COMMON_LABELS.HYPHEN
        : formatDate(apiResponse?.amexPosRegisterDate ?? ""),
      posRegistrationAnswerDate: isOmni
        ? COMMON_LABELS.HYPHEN
        : isStore
        ? COMMON_LABELS.HYPHEN
        : formatDate(apiResponse?.amexPosRegisterAnswerDate ?? ""),
      posRegistrationStatus: isOmni
        ? COMMON_LABELS.HYPHEN
        : isChangeExamination || isStore
        ? COMMON_LABELS.HYPHEN
        : getPosRegistrationStatusLabel(
            apiResponse?.amexPosRegisterStatus ?? -1
          ),
      merchantNo: isOmni
        ? COMMON_LABELS.HYPHEN
        : isStore
        ? COMMON_LABELS.HYPHEN
        : apiResponse?.amexMerchantNo ?? "",
      tenantMerchantNo: COMMON_LABELS.HYPHEN,
      accessKey: COMMON_LABELS.HYPHEN,
      secretKey: COMMON_LABELS.HYPHEN,
    },
    {
      examinationOrderTarget: LABELS.GMO_PG,
      examinationOrderDate: COMMON_LABELS.HYPHEN,
      examinationAnswerDate: COMMON_LABELS.HYPHEN,
      examinationStatus: COMMON_LABELS.HYPHEN,
      posRegistrationOrderDate: isOmni
        ? COMMON_LABELS.HYPHEN
        : isStore
        ? COMMON_LABELS.HYPHEN
        : formatDate(apiResponse?.gmoPosRegisterDate ?? ""),
      posRegistrationAnswerDate: isOmni
        ? COMMON_LABELS.HYPHEN
        : isStore
        ? COMMON_LABELS.HYPHEN
        : formatDate(apiResponse?.gmoPosRegisterAnswerDate ?? ""),
      posRegistrationStatus: isOmni
        ? COMMON_LABELS.HYPHEN
        : isChangeExamination || isStore
        ? COMMON_LABELS.HYPHEN
        : getPosRegistrationStatusLabel(
            apiResponse?.gmoPosRegisterStatus ?? -1
          ),
      merchantNo: COMMON_LABELS.HYPHEN,
      tenantMerchantNo: COMMON_LABELS.HYPHEN,
      accessKey: COMMON_LABELS.HYPHEN,
      secretKey: COMMON_LABELS.HYPHEN,
    },
    {
      examinationOrderTarget: LABELS.NTTDATA_V_M,
      examinationOrderDate: isOmni
        ? apiResponse?.nttDataVmExaminationOrderTargetStatus ===
          EXAMINATION_STATUS_NO_NEED_TO_IMPLEMENT
          ? COMMON_LABELS.HYPHEN
          : formatDate(apiResponse?.nttDataVmExaminationOrderTargetDate ?? "")
        : COMMON_LABELS.HYPHEN,
      examinationAnswerDate: isOmni
        ? apiResponse?.nttDataVmExaminationOrderTargetStatus ===
          EXAMINATION_STATUS_NO_NEED_TO_IMPLEMENT
          ? COMMON_LABELS.HYPHEN
          : formatDate(apiResponse?.nttDataVmExaminationAnswerDate ?? "")
        : COMMON_LABELS.HYPHEN,
      examinationStatus: isOmni
        ? getExaminationStatusLabel(
            apiResponse?.nttDataVmExaminationOrderTargetStatus ?? -1
          ) ?? COMMON_LABELS.BLANK
        : COMMON_LABELS.HYPHEN,
      posRegistrationOrderDate: COMMON_LABELS.HYPHEN,
      posRegistrationAnswerDate: COMMON_LABELS.HYPHEN,
      posRegistrationStatus: COMMON_LABELS.HYPHEN,
      merchantNo: isOmni
        ? apiResponse?.nttDataSettlementGroupId ?? ""
        : COMMON_LABELS.HYPHEN, // 決済グループID
      tenantMerchantNo: isOmni
        ? isStore
          ? apiResponse?.nttDataTenantSettlementGroupId ?? ""
          : COMMON_LABELS.HYPHEN
        : COMMON_LABELS.HYPHEN,
      accessKey: isOmni
        ? apiResponse?.nttDataAccessKey ?? ""
        : COMMON_LABELS.HYPHEN,
      secretKey: isOmni
        ? apiResponse?.nttDataSecretKey ?? ""
        : COMMON_LABELS.HYPHEN,
    },
    {
      examinationOrderTarget: LABELS.NTTDATA_JCB,
      examinationOrderDate: isOmni
        ? apiResponse?.nttDataVmExaminationOrderTargetStatus ===
          EXAMINATION_STATUS_NO_NEED_TO_IMPLEMENT
          ? COMMON_LABELS.HYPHEN
          : formatDate(apiResponse?.nttDataJcbExaminationOrderTargetDate ?? "")
        : COMMON_LABELS.HYPHEN,
      examinationAnswerDate: isOmni
        ? apiResponse?.nttDataVmExaminationOrderTargetStatus ===
          EXAMINATION_STATUS_NO_NEED_TO_IMPLEMENT
          ? COMMON_LABELS.HYPHEN
          : formatDate(apiResponse?.nttDataJcbExaminationAnswerDate ?? "")
        : COMMON_LABELS.HYPHEN,
      examinationStatus: isOmni
        ? getExaminationStatusLabel(
            apiResponse?.nttDataJcbExaminationOrderTargetStatus ?? -1
          ) ?? COMMON_LABELS.BLANK
        : COMMON_LABELS.HYPHEN,
      posRegistrationOrderDate: COMMON_LABELS.HYPHEN,
      posRegistrationAnswerDate: COMMON_LABELS.HYPHEN,
      posRegistrationStatus: COMMON_LABELS.HYPHEN,
      merchantNo: isOmni
        ? apiResponse?.nttDataSettlementGroupId ?? ""
        : COMMON_LABELS.HYPHEN, // 決済グループID
      tenantMerchantNo: isOmni
        ? isStore
          ? apiResponse?.nttDataTenantSettlementGroupId ?? ""
          : COMMON_LABELS.HYPHEN
        : COMMON_LABELS.HYPHEN,
      accessKey: isOmni
        ? apiResponse?.nttDataAccessKey ?? ""
        : COMMON_LABELS.HYPHEN,
      secretKey: isOmni
        ? apiResponse?.nttDataSecretKey ?? ""
        : COMMON_LABELS.HYPHEN,
    },
    {
      examinationOrderTarget: LABELS.NTTDATA_AMEX,
      examinationOrderDate: isOmni
        ? apiResponse?.nttDataVmExaminationOrderTargetStatus ===
          EXAMINATION_STATUS_NO_NEED_TO_IMPLEMENT
          ? COMMON_LABELS.HYPHEN
          : formatDate(apiResponse?.nttDataAmexExaminationOrderTargetDate ?? "")
        : COMMON_LABELS.HYPHEN,
      examinationAnswerDate: isOmni
        ? apiResponse?.nttDataVmExaminationOrderTargetStatus ===
          EXAMINATION_STATUS_NO_NEED_TO_IMPLEMENT
          ? COMMON_LABELS.HYPHEN
          : formatDate(apiResponse?.nttDataAmexExaminationAnswerDate ?? "")
        : COMMON_LABELS.HYPHEN,
      examinationStatus: isOmni
        ? getExaminationStatusLabel(
            apiResponse?.nttDataAmexExaminationOrderTargetStatus ?? -1
          ) ?? COMMON_LABELS.BLANK
        : COMMON_LABELS.HYPHEN,
      posRegistrationOrderDate: COMMON_LABELS.HYPHEN,
      posRegistrationAnswerDate: COMMON_LABELS.HYPHEN,
      posRegistrationStatus: COMMON_LABELS.HYPHEN,
      merchantNo: isOmni
        ? apiResponse?.nttDataSettlementGroupId ?? ""
        : COMMON_LABELS.HYPHEN, // 決済グループID
      tenantMerchantNo: isOmni
        ? isStore
          ? apiResponse?.nttDataTenantSettlementGroupId ?? ""
          : COMMON_LABELS.HYPHEN
        : COMMON_LABELS.HYPHEN,
      accessKey: isOmni
        ? apiResponse?.nttDataAccessKey ?? ""
        : COMMON_LABELS.HYPHEN,
      secretKey: isOmni
        ? apiResponse?.nttDataSecretKey ?? ""
        : COMMON_LABELS.HYPHEN,
    },
  ];

  const nttFItems: IExaminationTargetItems[] = [
    {
      examinationOrderTarget: LABELS.NTT_F,
      examinationOrderDate: formatDate(
        apiResponse?.nttfExaminationOrderTargetDate ?? ""
      ),
      examinationAnswerDate: formatDate(
        apiResponse?.nttfExaminationAnswerDate ?? ""
      ),
      examinationStatus: getExaminationStatusLabelMonthlyPeriodicCredit(
        apiResponse?.nttfExaminationOrderTargetStatus ?? -1,
        apiResponse?.examinationComprehensiveStatus ?? -1
      ),
      posRegistrationOrderDate: COMMON_LABELS.HYPHEN,
      posRegistrationAnswerDate: COMMON_LABELS.HYPHEN,
      posRegistrationStatus: COMMON_LABELS.HYPHEN,
      merchantNo: COMMON_LABELS.HYPHEN,
      tenantMerchantNo: COMMON_LABELS.HYPHEN,
      accessKey: COMMON_LABELS.HYPHEN,
      secretKey: COMMON_LABELS.HYPHEN,
    },
  ];
  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <SpaceBetween direction={"vertical"} size={"l"}>
      <Container>
        <ExaminationInfo
          examinationApplicationNo={examinationApplicationNo as string}
          applicationNo={apiResponse?.applicationNo ?? -1}
          applicationDate={apiResponse?.applicationDate ?? ""}
          applicationManager={apiResponse?.applicationManager ?? ""}
          applicationType={apiResponse?.updateDifferential ?? ""}
          examinationType={apiResponse?.examinationType ?? ""}
          isStore={isStore}
          registerName={apiResponse?.registerName ?? ""}
          companyName={
            isStore
              ? apiResponse?.storeName ?? ""
              : apiResponse?.merchantName ?? ""
          }
          businessStyle={
            isStore
              ? apiResponse?.storeBusinessStyle ?? ""
              : apiResponse?.merchantBusinessStyle ?? ""
          }
          corporateNumber={
            isStore
              ? apiResponse?.storeCorporateNumber ?? ""
              : apiResponse?.merchantCorporateNumber ?? ""
          }
          merchantName={apiResponse?.merchantStoreName ?? ""}
          examinationComprehensiveStatus={
            apiResponse?.examinationComprehensiveStatus ?? -1
          }
          approvalStatus={apiResponse?.approvalStatus ?? -1}
        />
        <Box margin={"s"}>
          <Table
            items={examinationTargetItems}
            nttFItems={nttFItems}
            isNttF={
              apiResponse?.examinationKbn ===
              EXAMINATION_APPLICATION_MONTHLY_PERIODIC_CREDIT
            }
          />
        </Box>
        <ExpandableSection headerText={LABELS.RELATED_EXAMINATION}>
          <Box margin={"s"}>
            <RelatedExaminationList
              examinationApplicationNo={examinationApplicationNo!}
            />
          </Box>
        </ExpandableSection>
      </Container>
      <Footer
        examinationApplicationNo={examinationApplicationNo!}
        isNttF={
          apiResponse?.examinationKbn ===
          EXAMINATION_APPLICATION_MONTHLY_PERIODIC_CREDIT
        }
      />
    </SpaceBetween>
  );
};
